import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { UnlockEmspUserByIdModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/inputs/emsp-users/unlock-emsp-user.model';
import React from 'react';
import { SubmitErrorHandler } from 'react-hook-form';

import { useUnlockEmspBoEmspUserContext } from '../../emsp-bo-emsp-user.context';
import { EmspBoEmspUserLockDeleteFormStep1Controller } from '../emsp-bo-emsp-user-delete-delete-form-step-1/emsp-bo-emsp-user-lock-delete-form-step-1.controller';

// /////////////////////////////////////////////////////////////////////////////

interface EmspBoEmspUserLockDeleteFormControllerProps {
  onError: SubmitErrorHandler<UnlockEmspUserByIdModel>;
  onSubmit: SubmitHandlerWithDirtyFields<UnlockEmspUserByIdModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoEmspUserLockDeleteFormController = (
  props: EmspBoEmspUserLockDeleteFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useUnlockEmspBoEmspUserContext();

  return (
    <MultiStepFormProvider<UnlockEmspUserByIdModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['userId'],
          component: <EmspBoEmspUserLockDeleteFormStep1Controller />,
        },
      ]}
    />
  );
};
